import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const TitleTipsStyle = styled.label`
  display: block;
  margin-top: 0.625rem;
  color: #a1a1a3;
`;
export const TitleTips = ({ children }) => {
  return <TitleTipsStyle>{children}</TitleTipsStyle>;
};

TitleTips.propTypes = {
  children: PropTypes.element
};
